import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    lang: "ru",
    showMainView: false
}

export const mainSlice = createSlice({
    name: "main",
    initialState,
    reducers: {
        setLang: (state, {lang}) => {
            state.lang = lang
        },
        setShowMainView: (state => {
            state.showMainView = true
        })
    }
})

export const { actions: mainSliceAction, reducer: mainSliceReducer} =  mainSlice